<template>
  <div>
    <bread-crumb></bread-crumb>
    <manFormList
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @empty="empty"
      :num="num"
      :isBtn="isBtn"
      @editorial_remoteMethod="editorial_remoteMethod"
    ></manFormList>
    <div class="wiki-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item, index) in jbbkTabList"
          :key="index"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.title }}</span
            ><span>{{ item.count }}</span>
          </span>
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="jbbkList" style="width: 100%">
                <el-table-column prop="contentId" label="疾病ID">
                </el-table-column>
                <el-table-column prop="icd" label="icd10ID"> </el-table-column>
                <el-table-column prop="contentName" label="疾病名称">
                </el-table-column>
                <el-table-column prop="departments" label="科室">
                  <template slot-scope="scope">
                    <span
                      v-for="(item, index) in scope.row.departments"
                      :key="index"
                    >
                      {{ item.departName
                      }}{{
                        index === scope.row.departments.length - 1 ? "" : "、"
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="上传人">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.authors && scope.row.authors.length > 0"
                  >
                    <span>{{ scope.row.authors[0].nickName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="上传时间">
                </el-table-column>
                <el-table-column prop="auditTime" label="审核时间">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditTime }}
                  </template>
                </el-table-column>
                <el-table-column prop="auditUser" label="审核人">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditUser }}
                  </template>
                </el-table-column>
                <el-table-column prop="auditUser" label="编审医生">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.doctorInfos.length > 0"
                  >
                    <span
                      v-for="(item, index) in scope.row.doctorInfos"
                      :key="index"
                    >
                      <span v-if="item.roleType == 2">
                        {{
                          item.docName +
                          " " +
                          item.titleName +
                          " " +
                          "ID: " +
                          item.docId +
                          " " +
                          item.departName +
                          " " +
                          item.hospitalGradeName +
                          " " +
                          item.hospitalName
                        }}
                      </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="auditStatus" label="审核状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.auditInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.auditInfo.auditStatus == 4"
                    >
                      <div
                        :class="
                          scope.row.auditInfo.auditStatus == 4 ? 'rejected' : ''
                        "
                      >
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.auditInfo.auditStatus | auditStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="auditStatus" label="文章状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="reasonForOffline"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.contentStatus == 2"
                    >
                      <div
                        :class="scope.row.contentStatus == 2 ? 'rejected' : ''"
                        @mouseenter="remarkContent(scope)"
                      >
                        {{ scope.row.contentStatus | contentStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.contentStatus | contentStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.auditInfo.auditStatus == 2"
                        @click="toAuditPage(scope.row)"
                        >审核
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.auditInfo.auditStatus == 2 &&
                          scope.row.contentStatus == 1
                        "
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1
                            ? false
                            : scope.row.auditInfo.auditStatus == 2
                            ? false
                            : true
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1 &&
                          scope.row.contentStatus == 2
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.contentStatus == 1 &&
                          scope.row.auditInfo.auditStatus !== 2 &&
                          scope.row.auditInfo.auditStatus !== 1
                        "
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        @click="articlePreview(scope.row)"
                        >查看线上
                      </el-button>
                      <span
                        class="border"
                        v-if="scope.row.contentStatus == 1"
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        @click="offlineDisease(scope.row)"
                        v-if="scope.row.contentStatus == 1"
                        >下线
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <modal
      :isShow.sync="offlineDialog"
      title="下线"
      :width="width"
      :isShowBtn="isShowBtn"
      :btnText="ordinaryBtnText"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <span class="red">*</span>
        <el-form-item label="下线理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import {
  getReviewStatus,
  getDiseaseSymptoms,
  changgeDiseaseSymptomsOnline,
} from "@/api/symptomaticDisease";
import { getDoctorInformation } from "../../../../../api/man";
import modal from "@/components/modal";

const baseUrl = process.env.VUE_APP_BASEURL;

import baseDialog from "../../../components/baseDialog";

export default {
  name: "wikiList",
  data() {
    return {
      num: 1,
      activeName: "all",
      jbbkList: [],
      jbbkTabList: [
        {
          name: "all",
          title: "全部",
          count: 0,
          type: "allCount",
        },
        {
          name: "unaudit",
          title: "待审核",
          count: 0,
          type: "unAuditCount",
        },
        {
          name: "approved",
          title: "审核通过",
          count: 0,
          type: "passAuditCount",
        },
        {
          name: "rejected",
          title: "已驳回",
          count: 0,
          type: "rejectCount",
        },
      ],
      rejectlineDialog: false,
      rejectReasons: "",
      applyReason: "",
      isShowBtn: [true, true], //弹窗是否能显示按钮
      ordinaryBtnText: ["取消", "确认"],
      offLineReasons: "",
      offLineInfo: "",
      contentAuditStatusList: [1, 2, 3, 4],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleStatus: [],
      articleListCode: 0,
      originalAuthorName: "",
      isShowBtn: [true, true, false],
      reviewOfflineDialog: false, // 审核下线申请
      btnText: ["驳回", "通过"],
      targetValue: null,
      formData: {
        formList: {
          title: "下线文章",
          infoKey: "下线理由",
          infoValue: "",
          placeholder: "请输入下线理由",
          maxlength: "200",
          type: 2, //0(13\16) or 1(28)
        },
      },
      mUrl: "",
      offlineDialog: false,
      reason: "", //理由
      formlist: [],
      selectList: {
        queryItem: "", // 输入疾病ID
        selectDiseaseInfoId1: "", // 输入疾病名称
        selectedDeparttId: [], // 输入科室名称
        submissionTime: [], // 投稿时间
        contentStatus: "", // 问文章状态
        editorialDoctor: "", // 编审医生
      },
      isBtn: 1,
      select: [
        {
          prop: "queryItem",
          type: "input",
          placeholder: "请输入疾病ID",
        },
        {
          prop: "selectDiseaseInfoId1",
          type: "input1",
          placeholder: "请输入疾病名称",
          // List:[]
        },
        {
          prop: "contentStatus",
          type: "select",
          placeholder: "请选择文章状态",
          List: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "已上线",
              value: 1,
            },
            {
              label: "已下线",
              value: 2,
            },
          ],
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择投稿时间",
          // List:[]
        },
        {
          prop: "selectedDeparttId",
          type: "cascader",
          placeholder: "请输入科室名称",
          // List:[]
        },
        {
          prop: "editorialDoctor",
          type: "editorialDoctor",
          placeholder: "请输入编审医生",
          List: [],
        },
      ],
      reasonForOffline: "",
      baseUrl,
    };
  },
  components: {
    manFormList,
    breadCrumb,
    pagination,
    modal,
  },
  created() {
    // 是否由文章详情页跳转本页面
    this.initializeJump();
    this.pageDiseaseInfoDraftList();
    this.getDiseaseDraftCountList();
  },
  mounted() {},
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("disease");
  },
  filters: {
    auditStatus: function (data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    contentStatus: function (data) {
      switch (data) {
        case 1:
          return "已上线";
        case 2:
          return "已下线";
        default:
          return "";
      }
    },
  },
  methods: {
    editorial_remoteMethod(val) {
      getDoctorInformation({
        tenantId: this.$commonJs.getTenantId(),
        doctorName: val,
      })
        .then((res) => {
          let arr = res.map((itemRes) => {
            return {
              value: itemRes.docId,
              label:
                itemRes.docName +
                " " +
                itemRes.titleName +
                " " +
                itemRes.hospitalGradeName +
                " " +
                itemRes.hospitalName +
                " " +
                itemRes.departName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "editorialDoctor") {
              item.List.splice(0, item.List.length);
              item.List = arr;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 回到列表页 跳转
    initializeJump() {
      if (sessionStorage.getItem("disease")) {
        let contentStatus = sessionStorage.getItem("contentAuditStatus");
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("currentPage");
        this.selectList = JSON.parse(sessionStorage.getItem("select"));
        this.activeName = sessionStorage.getItem("activeName");
        if (contentStatus == "1,2,3,4") {
          this.contentAuditStatusList = [1, 2, 3, 4];
        } else {
          this.contentAuditStatusList = [contentStatus];
        }
      } else {
        this.paginationDataProduct.currentPage = 1;
        this.selectList.queryItem = "";
        this.selectList.selectDiseaseInfoId1 = "";
        this.selectList.selectedDeparttId = [];
        this.selectList.submissionTime = [];
        this.selectList.contentStatus = "";
        this.activeName = "all";
        this.contentAuditStatusList = [1, 2, 3, 4];
      }
    },
    // 查看线上
    articlePreview(row) {
      if (row.contentType == 8) {
        this.jumpUrl("disease/", row.contentId);
      }
      if (row.contentType == 9) {
        this.jumpUrl("symptom/", row.contentId);
      }
    },
    jumpUrl(url, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.healthjd.com/wiki/";
      let previewUrl2 = "https://cont.healthjd.com/wiki/";
      let newUrl =
        this.baseUrl == urlAddress
          ? previewUrl1 + url + urlId
          : previewUrl2 + url + urlId;
      window.open(newUrl);
    },
    remarkContent(i) {
      if (i.row.statusInfo) {
        this.reasonForOffline = i.row.statusInfo.remark;
      } else {
        this.reasonForOffline = "";
      }
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "all") {
        this.articleListCode = 0;
      } else if (tab.name === "unaudit") {
        this.articleListCode = 2;
      } else if (tab.name === "approved") {
        this.articleListCode = 3;
      } else if (tab.name === "rejected") {
        this.articleListCode = 4;
      }
      if (this.articleListCode !== 0) {
        this.contentAuditStatusList.splice(
          0,
          this.contentAuditStatusList.length
        );
        this.contentAuditStatusList.push(this.articleListCode);
      } else {
        this.contentAuditStatusList = [1, 2, 3, 4];
      }
      this.pageDiseaseInfoDraftList("1");
      this.getDiseaseDraftCountList();
    },
    // 查询文章
    getChangeValue(data) {
      if (this.$utils.checkNumber(data.queryItem)) {
        this.pageDiseaseInfoDraftList("1");
        this.getDiseaseDraftCountList();
      } else {
        this.$message({
          message: "ID只能为数字",
          type: "warning",
        });
      }

      // this.selectList.submissionTime[0],
      // endTime:this.selectList.submissionTime[1],
    },
    // 跳转审核页
    toAuditPage(data) {
      this.$router.push({
        path: "/wikiManage/diseaseEdit",
        query: {
          id: data.contentId,
          contentType: 1,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    getCreateUserPin(row) {
      // let data = row.contentUserInfos[0]
      // if(data.userContentRole == 1) {
      //   return data.pin
      // }
    },
    // 跳转编辑页
    toEditPage(data) {
      this.$router.push({
        path: "/wikiManage/diseaseEdit",
        query: {
          id: data.contentId,
          contentType: 1,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("contentAuditStatus", this.contentAuditStatusList);
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      sessionStorage.setItem("select", selectStr);
    },
    // 下线文章
    offlineDisease(data) {
      this.offLineReasons = "";
      this.offlineDialog = true;
      this.getOffLineInfo(data);
    },
    getOffLineInfo(data) {
      this.offLineInfo = data;
    },
    offlineClickHandler(type) {
      if (type == "one") {
        this.offlineDialog = false;
      } else if (type == "two") {
        if (this.offLineReasons === "") {
          this.$message.error("请输入下线理由");
          return;
        }
        changgeDiseaseSymptomsOnline({
          contentId: this.offLineInfo.contentId,
          tenantId: this.$commonJs.getTenantId(),
          contentStatus: 2,
          remark: this.offLineReasons,
        }).then((res) => {
          this.$message.success("下线成功");
          this.offlineDialog = false;
          this.pageDiseaseInfoDraftList();
        });
      }
    },
    getParams() {
      let contentDoctorBizParams = [];
      if (this.selectList.editorialDoctor) {
        contentDoctorBizParams.push({
          docId: this.selectList.editorialDoctor,
          roleType: 2,
        });
      }
      let params;
      return (params = {
        contentType: 8,
        contentDoctorBizParams: contentDoctorBizParams || [],
        contentId: this.selectList.queryItem || null,
        aliasNamePrecise: this.selectList.selectDiseaseInfoId1 || null,
        departIds:
          this.selectList.selectedDeparttId == []
            ? []
            : [...new Set(this.selectList.selectedDeparttId.flat(Infinity))],
        contentStatus: this.selectList.contentStatus
          ? [this.selectList.contentStatus]
          : [],
        tenantId: this.$commonJs.getTenantId(),
        startTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        auditStatus: [1, 2, 3, 4],
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      });
    },
    // 获取各种状态的数量
    getDiseaseDraftCountList() {
      let params = this.getParams();
      getReviewStatus(params).then((res) => {
        this.jbbkTabList.forEach((item) => {
          item.count = res[item.type];
        });
      });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageDiseaseInfoDraftList();
    },
    pageDiseaseInfoDraftList(val) {
      let contentDoctorBizParams = [];
      contentDoctorBizParams.push({
        doctorId: this.selectList.editorialDoctor,
        roleType: 2,
      });
      if (val == "1") {
        this.paginationDataProduct.currentPage = 1;
      }
      var patrn = /[0-9]/im;
      if (this.selectList.queryItem && !patrn.test(this.selectList.queryItem)) {
        return this.$message.error("请填写正确的ID");
      }
      let params = this.getParams();
      params.auditStatus = this.contentAuditStatusList;
      getDiseaseSymptoms(params).then((res) => {
        this.jbbkList.splice(0, this.jbbkList.length);
        res.data.map((item) => {
          this.jbbkList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    handleDialog(val) {
      this.seeReasonDialog = val;
      this.reviewOfflineDialog = val;
    },
    getTargetValue(target) {
      this.targetValue = target;
    },
    offlineDialogHandel(data) {
      this.offlineDialogShow = data;
    },
    // 清空筛选
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.select.map((item) => {
        if (item.prop == "editorialDoctor") {
          item.List = [];
        }
      });
      this.pageDiseaseInfoDraftList();
      this.getDiseaseDraftCountList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wiki-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.freezeDom {
  margin-top: 30px;

  .freezeInp {
    maxheight: 280px;
    max-width: 276px;
    // overflow: hidden;
    // height: 120px;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  :deep(.el-textarea__inner) {
    min-height: 145px !important;
    max-height: 280px !important;
  }

  :deep(.el-form-item__label) {
    line-height: 15px;
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

:deep(.cell) {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
  // overflow: visible !important;
}

// .tableLimit tr td .cell{
//   overflow : hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;      /*可以显示的行数，超出部分用...表示 */
//   -webkit-box-orient: vertical;

// }
// :deep(.el-table .cell) {
//   white-space: wrap;
//   width: fit-content;
// }
.base-dialog {
  width: 400px;
  padding: 30px 26px 30px 26px !important;
  font-size: 14px;
  color: #2c3443;
}

.red {
  margin-left: 24px;
  // margin-top: 12px;
  position: absolute;
  color: red;
}

.rejected:hover {
  cursor: pointer;
  color: red;
}
</style>
